import { formatDateToUTC } from '#client/utils/helpers';
import PURCHASE_ORDER_STRINGS from '#client/pages/PurchaseOrders/constants/purchaseOrders.en.json';

export const mapReceivingDocuments = (advancedShippingNotices) => {
    return advancedShippingNotices.flatMap((rd) => ({
        id: rd.id,
        createdAt: formatDateToUTC(rd.createdAt),
        quantityReceived: rd.quantityReceived,
        status: rd.status,
        totalCartonLines: rd.lines?.reduce((total, line) => total + line.quantityExpected, 0),
        updatedAt: formatDateToUTC(rd.updatedAt),
    }));
};

export const getProductInfo = (entry) => {
    let hasProduct = false;
    let productName;

    if (entry.product) {
        productName = entry.product;
        hasProduct = true;
    }
    if (entry.variant) {
        productName = entry.variant?.variantTitle;
        hasProduct = entry.variant.variantTitle ? true : false;
    }

    return {
        productName: productName || PURCHASE_ORDER_STRINGS.PURCHASE_ORDER_DETAIL.EXPECTED_ITEMS_TABLE.NO_PRODUCT_FOUND,
        tone: hasProduct === true ? 'normal' : 'critical',
        textWeight: hasProduct === true ? 'medium' : 'normal',
    };
};
